<template>
  <Accordion type="single" collapsible class="w-full">
    <AccordionItem v-for="(item, i) in items" :key="i" :value="`${item.question}-${i}`" class="py-4">
      <AccordionTrigger :class="titleColorClass" class="hover:no-underline text-xl cursor-pointer">
        {{ item.question }}
        <template #icon>
          <CirclePlus
            :size="20"
            class="icon-closed text-grey-light-400 pointer-events-none shrink-0 transition-opacity duration-200"
          />
          <CircleMinus
            :size="20"
            class="icon-open text-grey-light-400 pointer-events-none shrink-0 transition-opacity duration-200"
          />
        </template>
      </AccordionTrigger>
      <AccordionContent :class="contentColorClass" class="text-lg">
        {{ item.answer }}
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>

<script setup lang="ts">
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useThemeStore } from '@/stores/theme';
import { CircleMinus, CirclePlus } from 'lucide-vue-next';
import { computed } from 'vue';

defineProps<{
  items: Array<{ question: string; answer: string }>;
}>();

const themeStore = useThemeStore();

const titleColorClass = computed(() => {
  return themeStore.mode === 'business' ? 'text-grey-dark-50' : 'text-grey-light-900';
});

const contentColorClass = computed(() => {
  return themeStore.mode === 'business' ? 'text-grey-dark-300' : 'text-grey-light-600';
});
</script>

<style scoped>
[data-state='open'] .icon-closed {
  display: none;
}

[data-state='closed'] .icon-open {
  display: none;
}
</style>
